import IWord from "./models/IWord";

const dummyWords = [
  [
    { value: "in", verseNumber: 1 },
    { value: "the", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
    { value: "beginning,", verseNumber: 1 },
  ],
  [
    { value: "god", verseNumber: 1 },
    { value: "created", verseNumber: 1 },
    { value: "the", verseNumber: 1 },
    { value: "heavens", verseNumber: 1 },
    { value: "and", verseNumber: 1 },
    { value: "the", verseNumber: 1 },
    { value: "earth", verseNumber: 1 },
  ],
] as IWord[][];

export default dummyWords;
